
import SimpleHeader from "components/Headers/SimpleHeader.jsx";
import React from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Container,
  Form
} from "reactstrap";
import EventService from "../../../services/eventService";
import CourseForm from "./Form";

class EventEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            errorData: {},
            curriculumYearList: []
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        const {uniqueId} = this.props.match.params;
        EventService.fetch(uniqueId).then(response => {
            console.log(response.data);
            this.setState(response.data);
            this.setState({uniqueId: uniqueId});
        });
    }

    handleChange(event) {
        this.setState({[event.target.name]: event.target.value});
        console.log(this.state);
    }

    handleSubmit(event) {
        event.preventDefault();
        EventService.update(this.state).then(response => {
            console.log(response.data);
            if (response.responseStatus === "SUCCESS") {
                this.props.history.push("/crm/event/list");
            } else {
                this.setState({errorData: response.data});
                console.error("Error    ==>     " + response.message);
            }
        });
    }

    render() {
        return (
            <>
                <SimpleHeader
                    name="Edit"
                    parentName="Event"
                    heading="ClashMate"
                    newBtnUrl="/crm/event/list"
                    newBtnText="List All Events"
                />
                <Container className="mt--6" fluid>
                    <Card className="mb-4">
                        <CardHeader>
                            <h3 className="mb-0">Edit Event</h3>
                        </CardHeader>
                        <CardBody>
                            <Form role="form" onSubmit={this.handleSubmit}>
                                <CourseForm
                                    onChange={this.handleChange}
                                    valueObj={this.state}
                                    errorObj={this.state.errorData}
                                />
                                <div className="text-center">
                                    <Button className="my-4" color="default" outline type="submit">
                                        Update
                                    </Button>
                                </div>
                            </Form>
                        </CardBody>
                    </Card>
                </Container>
            </>
        );
    }
}

export default EventEdit;
